/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-26 17:21:58
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-06-26 16:10:19
 * @FilePath: /mmtv2-frontend-pc/packages/share/utils/reduceTopNavPath.ts
 * @Description:增加顶部路径的函数
 *
 */
import { da } from "date-fns/locale";
import localforage from "localforage";
import router from "@/router";

export default function reducePath(length: number, path: string, routerFn?: any, query?: any) {
  //   let localCachePath = localStorage.getItem("menuPath")
  //   if (localCachePath) {
  //     let pathArr = JSON.parse(localCachePath)
  //     let i = 0
  //     while (i < length) {
  //       pathArr.pop()
  //       i++
  //     }
  //     const tabItem = new CustomEvent("updateMenuPathEvent", { detail: pathArr })
  //     window.dispatchEvent(tabItem)
  //   }

  if (typeof routerFn !== "function") {
    //强制用新写法，以后删除这个代码
    router.push({ path: "/" });
    alert("请使用写的跳转写法");
    return;
  }

  localforage.getItem("allActive3LevelMenuData").then((data: any) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].isClick) {
        data.splice(i, 1);
        i--;
        break;
      } else {
        data[i].isClick = false;

        if (path == data[i].url) {
          data[i].isClick = true;
          data[i].query = query;
          localStorage.setItem("current3LevelMenu", JSON.stringify(data[i]));
          localStorage.setItem("btnList", JSON.stringify(data[i].btnList)); //存储按钮权限

          let menuPath = [{ name: data[i].name, path: data[i].url, query: data[i].query }];
          localStorage.setItem("menuPath", JSON.stringify(menuPath));
        }
      }
    }
    routerFn(); //current3LevelMenu 设置完后，在修改路由

    localforage.setItem("allActive3LevelMenuData", data).then((value: any) => {
      const tabItem = new CustomEvent("allActive3LevelMenuDataEvent", {
        detail: { allActive3LevelMenuData: value },
      });
      window.dispatchEvent(tabItem);
    });
  });
}
